<template>
    <vx-alert color="danger" class="vx-rounded-none" :closeable="false">
        <template v-slot:icon>
            <font-awesome-icon :icon="faTriangleExclamation" />
        </template>
        <div class="vx-flex vx-items-center vx-justify-between">
            <span>You are impersonating <strong>{{ userName }}</strong> {{ props.userRole }} of <strong>{{ teamName }}</strong></span>
            <vx-button href="/spark/kiosk/users/stop-impersonating" color="danger" size="sm">
                Stop Impersonating
                <font-awesome-icon :icon="faSquareArrowUpLeft"></font-awesome-icon>
            </vx-button>
        </div>
    </vx-alert>
</template>

<script setup>
import { VxAlert, VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSquareArrowUpLeft, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps({
    userRole: {
        type: String,
        required: true,
    },
});

const userName = Spark.state.user.name;
const teamName = Spark.state.currentTeam.name;
</script>
